import { exists } from "../../_helper/util.helper";
import { LinkModel } from "./menu/link.model";

export class MenuModel {

  public cloneText: string = 'Clone';

  public showDocuments: boolean = true;
  public showPhotos: boolean = true;

  public showImport: boolean = false;
  public importText: string = 'Import Public Data';

  public links: LinkModel[] = [];

  constructor(model?: Partial<MenuModel>) {
    if (model?.cloneText) this.cloneText = model.cloneText
    if (model?.links?.length) this.links = model.links.map(link => new LinkModel(link));
    if (exists(model?.showDocuments)) this.showDocuments = model.showDocuments;
    if (exists(model?.showPhotos)) this.showPhotos = model.showPhotos;
  }
}
